<!--
 * @Description: 常规工作/日常事务 工资发放
 * @Author: 王赵坤
 * @Date: 2022-12-28 15:57:15
 * @LastEditors: PF
 * @LastEditTime: 2023-09-13 16:32:02
-->
<template>
  <div>
    <el-dialog class="wp80 hp80" :model-value="openList" :close-on-click-modal="false" :show-close="false" destroy-on-close>
      <template #header>
        <div class="header-left">
          <el-icon class="header-icon">
            <Suitcase />
          </el-icon>
          <span class="header-title">工资发放</span>
        </div>
        <div class="header-right">
          <el-button type="info" text @click="openList=false;homeCloseWindow('openReturn', emits, false)">
            <el-icon>
              <Close />
            </el-icon>
          </el-button>
        </div>
      </template>
      <div class="list-page pl0 pr0 pt0 pb0">
        <el-container>
          <el-header>
            <!-- 搜索区域 BEGIN -->
            <el-form class="search-box" :model="dataGrid.parms" @submit.enter.prevent>

              <el-form-item>
                <el-select placeholder="工资类型" v-model="dataGrid.parms.gzlx" clearable filterable @change="bindTable()">
                  <el-option label="正常" :value="0" />
                  <el-option label="补发" :value="1" />
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-date-picker placeholder="工资年月" v-model="dataGrid.parms.gzny" type="month" format="YYYY-MM" value-format="YYYY-MM" @change="bindTable()" />
              </el-form-item>
              <el-form-item>
                <el-input placeholder="工号/姓名" v-model="dataGrid.parms.keyword" clearable @clear="bindTable()" @keyup.enter="bindTable()">
                  <template #suffix>
                    <el-icon class="el-input__icon pointer" @click="bindTable()">
                      <search />
                    </el-icon>
                  </template>
                </el-input>
              </el-form-item>
            </el-form>
            <!-- 搜索区域 END -->
            <!-- 按钮区域 BEGIN -->
            <div class="button-box">
              <el-button type="primary" @click="openAdd=true">批量发放</el-button>
              <el-dropdown>
                <el-button class="w200" type="info">
                  <el-icon class="el-icon--left">
                    <DocumentCopy />
                  </el-icon>导入/导出<el-icon class="el-icon--right"><arrow-down /></el-icon>
                </el-button>
                <template #dropdown>
                  <el-dropdown-menu class="w200">
                    <el-dropdown-item>
                      <el-upload :http-request="importInsert" :auto-upload="true" :show-file-list="false" accept=".xlsx, .xls">Excel导入数据</el-upload>
                    </el-dropdown-item>
                    <el-dropdown-item>
                      <el-upload :http-request="importCover" :auto-upload="true" :show-file-list="false" accept=".xlsx, .xls">Excel覆盖数据</el-upload>
                    </el-dropdown-item>
                    <el-dropdown-item @click="exportData" divided>导出到Excel</el-dropdown-item>
                    <el-dropdown-item @click="download">下载Excel模板</el-dropdown-item>
                  </el-dropdown-menu>
                </template>
              </el-dropdown>
            </div>
            <!-- 按钮区域 END -->
          </el-header>
          <el-main>
            <el-table :data="dataGrid.data" :default-sort="dataGrid.orderBy" show-summary v-loading="dataGrid.loading" @sort-change="dataGrid.sortChange" @selection-change="dataGrid.selectionChange" height="100%" border stripe>
              <!-- 冻结列-Left BEGIN -->
              <el-table-column type="selection" width="55" align="center" />
              <el-table-column label="工号" prop="gh" fixed align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']" />
              <el-table-column label="姓名" prop="xm" fixed align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']" />
              <el-table-column label="开户名" prop="khxm" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']" />
              <el-table-column label="开户银行" prop="khyh" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']" />
              <el-table-column label="银行卡号" prop="yhkh" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']" />
              <el-table-column label="工资类型" prop="gzlx" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']">
                <template #default="scope">
                  <el-tag v-if="scope.row.gzlx === 0" type="success">正常</el-tag>
                  <el-tag v-if="scope.row.gzlx === 1" type="info">补发</el-tag>
                </template>
              </el-table-column>
              <el-table-column label="实发金额" prop="sfje" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']" />
              <el-table-column :label="item.gzxmc" v-for="(item,index) in gongzixiang" :key="item.id" prop="je" align="center" show-overflow-tooltip>
                <template #default="scope">
                  <span>{{scope.row.gzbgzxs[index].je}}</span>
                </template>
              </el-table-column>
              <el-table-column label="状态" prop="zt" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']">
                <template #default="scope">
                  <el-tag v-if="scope.row.zt === 0" type="success">未发放</el-tag>
                  <el-tag v-if="scope.row.zt === 9" type="info">已发放</el-tag>
                </template>
              </el-table-column>
              <!-- 冻结列-Right BEGIN -->
              <el-table-column label="操作" width="180" fixed="right" align="center">
                <template #default="scope">
                  <el-button link type="primary" v-if="scope.row.zt === 0" @click="openAdd=true;setdata=scope.row">发放</el-button>
                </template>
              </el-table-column>
              <!-- 冻结列-Right END -->
            </el-table>
          </el-main>
        </el-container>
      </div>
    </el-dialog>
  </div>
  <add v-if="openAdd" v-model:openAdd="openAdd" @ReturnData="primary" />
</template>

<script setup>
import { ref, watch, defineProps, defineEmits } from 'vue'
import {
  loadList,
  submitExcel,
  exportExcel,
  downloadTemplate,
  loadSelect,
  actionPost,
  homeCloseWindow
} from '@/api/common.js'
import { warningPrompt } from '@/utils/promptInfo.js'
import add from './add.vue'

const props = defineProps({
  open: { type: String, required: true },
  row: { type: Object, required: false }
})
const emits = defineEmits(['openReturn', 'ReturnData'])

const gongzixiang = ref([])
const gznydata = ref([]) // 教职工list
const setdata = ref(null) // 存储单条数据

const dataGrid = ref({
  parms: {},
  data: [],
  pagination: {},
  loading: false,
  orderBy: { prop: 'gh', order: 'ascending' }, // ['ascending', 'descending']
  multipleSelection: [],
  sortChange: function (column) {
    dataGrid.value.orderBy.prop = column.prop
    dataGrid.value.orderBy.order = column.order
    bindTable()
  },
  selectionChange: function (selection) {
    dataGrid.value.multipleSelection = selection.map((item) => item.id)
  }
})
const bindTable = async (pageNo, pageSize) => {
  dataGrid.value.data = []
  gongzixiang.value = []
  loadList({
    url: '/api/v2/caiwu/jiaozhigonggongzibiao/fafanglist',
    pageNo: pageNo || 1,
    pageSize: pageSize || 100,
    dataGrid: dataGrid.value,
    loadSuccess: function (res) {
      dataGrid.value.data = res.data.pagelist.list
      loadSelect({
        url: '/api/v2/caiwu/caiwugongzixiang/list',
        data: gongzixiang,
        order: 'sx',
        sort: 'asc',
        loadSuccess: function (res) {
          dataGrid.value.data.forEach((item, index) => {
            item.gzny = dataGrid.value.parms.gzny
            gongzixiang.value = res.data
            if (item.id === null) {
              gongzixiang.value.forEach((element) => {
                element.je = 0
              })
              item.gzbgzxs = JSON.parse(JSON.stringify(gongzixiang.value))
            } else {
              const gongzixiangid = item.jzggzxs.map((gzx) => {
                return gzx.gzxid
              })
              gongzixiang.value.forEach((element) => {
                item.jzggzxs.forEach((gzxid) => {
                  if (
                    element.id === gzxid.gzxid &&
                    gzxid.jzgid === item.jzgid
                  ) {
                    element.je = gzxid.je
                  } else if (
                    gongzixiangid.indexOf(element.id) === -1 &&
                    gzxid.jzgid === item.jzgid
                  ) {
                    element.je = 0
                  }
                })
              })
              item.gzbgzxs = JSON.parse(JSON.stringify(gongzixiang.value))
            }
          })
        }
      })
    }
  })
}

// 发放
const primary = async (val) => {
  let ids = []
  if (dataGrid.value.multipleSelection.length !== 0) {
    ids = dataGrid.value.multipleSelection
  } else if (dataGrid.value.multipleSelection.length === 0) {
    if (setdata.value === null) {
      return warningPrompt('至少选择一行')
    }
    ids.push(setdata.value.id)
  }
  actionPost({
    url: '/api/v2/caiwu/jiaozhigonggongzibiao/shenpi',
    data: { ids: ids, ffrq: val.ffrq }
  }).then((res) => {
    if (res.code === 200) {
      bindTable()
    } else {
      warningPrompt(res.message)
    }
  })
}
// 弹窗
const openAdd = ref(false)
const openList = ref(false)

watch(
  () => props.open,
  () => {
    if (props.open === 'gongzifafang') {
      openList.value = true
      loadSelect({
        url: '/api/v2/caiwu/caiwugongzibiao/list',
        data: gznydata,
        order: 'gzny',
        sort: 'desc',
        loadSuccess: function (res) {
          dataGrid.value.parms.gzny = res.data[0].gzny
          bindTable()
        }
      })
      bindTable()
    } else {
      openList.value = false
    }
  },
  { deep: true, immediate: true }
)

// Excel导入数据
const importInsert = async (file) => {
  submitExcel({
    url: '/api/v2/caiwu/caiwugongzijizhun/importInsert',
    file: file,
    callback: function () {
      bindTable()
    }
  })
}
// Excel覆盖数据
const importCover = async (file) => {
  submitExcel({
    url: '/api/v2/caiwu/caiwugongzijizhun/importCover',
    file: file,
    callback: function () {
      bindTable()
    }
  })
}

// Excel导出
const exportData = async () => {
  exportExcel('/api/v2/caiwu/caiwugongzijizhun/export', dataGrid.value)
}

// 模板下载
const download = async () => {
  downloadTemplate('/api/v2/caiwu/caiwugongzijizhun/download')
}
</script>
